import {CALL} from "./reduxMiddleware";

const call = (params) => ({
    ...params,
    type: CALL,
});

export default call;
